import React from 'react';
import ReactDOM from 'react-dom';
import App from './containers/App';
import axios from 'axios';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '@flaticon/flaticon-uicons/css/all/all.css';

axios.defaults.baseURL = window.location.hostname === 'localhost'?'http://localhost:8080':`${window.location.protocol}//console.metromatrixonlineconsultation.com`;

axios.defaults.headers.post['Content-Type'] = 'application/json';

axios.interceptors.request.use(request => {
    return request;
}, error => {
    console.log(error);
    return Promise.reject(error);
});

axios.interceptors.response.use(response => {
    return response;
}, error => {
    console.log(error);
    return Promise.reject(error);
});

ReactDOM.render(<App />, document.getElementById('root'));
